module.exports = __webpack_public_path__ + "ee3034bd72c3fe887df6e35bb180ab49.svg";